var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"has-details",class:{'shown': _vm.isSelected},on:{"click":function($event){return _vm.onRowClick(_vm.user.id)}}},[_c('td',[_vm._v(_vm._s(_vm.user.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.userFullName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.user.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.userPhoneNumber))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-640256b3","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Users/UserRowItem.vue
// module id = 1908
// module chunks = 0